module.exports = __webpack_public_path__ + "img/cute_natural_doodle_1.43b6cfb9.png";